module.exports = __webpack_public_path__ + "static/media/lmc.83bcec7f.png";